/* eslint-disable react/no-danger */
import React, { useContext } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Accordion, AccordionTitle, AccordionBody } from '@thd-olt-component-react/core-ui';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import styles from './faq.module.scss';

const cx = classNames.bind(styles);

const Faq = ({ faq }) => {
  const { isServer } = useContext(ExperienceContext);
  if (!faq.length > 0) return null;
  const iconObj = {
    position: 'left',
    size: 'sm'
  };
  return (
    <div className={cx('faq')}>
      {faq.map((accordion, index) => (
        <Accordion icon={iconObj} key={index} expanded>
          <AccordionTitle className={cx('faq__question')}>
            {accordion.question}
          </AccordionTitle>
          <AccordionBody className={cx('faq__text')}>
            <div dangerouslySetInnerHTML={{ __html: accordion.answer }} />
          </AccordionBody>
        </Accordion>
      ))}
    </div>
  );
};

Faq.propTypes = {
  faq: PropTypes.arrayOf(PropTypes.shape({
    question: PropTypes.string,
    answer: PropTypes.string
  })).isRequired
};

export { Faq };